import classNames from '@ui-components-3/ui/lib/utils/classNames'
import UserGroupIcon from '@ui-components-3/icons/lib/duotone/UserGroup'
import ClockIcon from '@ui-components-3/icons/lib/solid/Clock'

import { useMemo } from 'react'

type PlaceholderProps = {
  text: string
  textClassName?: string
  icon: string
  iconSize?: 'sm' | 'lg'
  iconColorClassName?: string
  description?: string
}

const iconSizeClassNames = {
  sm: 'w-[98px] h-[98px]',
  lg: 'w-[200px] h-[200px]',
}

const Placeholder = ({
  text,
  textClassName = '',
  icon,
  iconSize = 'sm',
  iconColorClassName,
  description,
}: PlaceholderProps) => {
  const { Icon, iconClassName } = useMemo(() => {
    switch (icon) {
      case 'visits':
        return { Icon: ClockIcon, iconClassName: iconColorClassName || 'text-neutral-800' }
      case 'queue':
        return { Icon: UserGroupIcon, iconClassName: iconColorClassName || 'text-primary-800' }

      default: {
        return {}
      }
    }
  }, [icon, iconColorClassName])

  const iconSizeClassName = iconSizeClassNames[iconSize || 'sm']

  return (
    <div className="mt-10 p-4 gap-6 flex flex-col items-center justify-center text-center text-neutral-500 typography-body-xxl leading-loose">
      {!!Icon && <Icon className={classNames(iconSizeClassName, iconClassName)} aria-hidden="true" />}
      <div>
        <h5 className={textClassName}>{text}</h5>
        {!!description && <p className="typography-h5">{description}</p>}
      </div>
    </div>
  )
}

export default Placeholder
